import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LEGACY_REDIRECTS: Record<string, string> = {
  "/categoria-produto/cursos-online": "/cursos-gravados",
};

export const LegacyRedirects: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();

    if (LEGACY_REDIRECTS[currentPath]) {
      navigate(LEGACY_REDIRECTS[currentPath], { replace: true });
      return;
    }
  }, [location, navigate]);

  return null;
};

export default LegacyRedirects;
